import React from "react";

const SvgFolderFile1 = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M23.273 12.116a1 1 0 00-.774-.366H10.2a1 1 0 01-.981-.8l-.278-1.397a1 1 0 00-.981-.8H1.5a1 1 0 00-.98 1.2l2.6 13a1 1 0 00.981.8H20.5a1 1 0 00.98-.8l2-10a1 1 0 00-.207-.837zM5.5 7.75a1 1 0 001-1v-4a.5.5 0 01.5-.5h12a.5.5 0 01.5.5v7a1 1 0 002 0v-7.5a2 2 0 00-2-2h-13a2 2 0 00-2 2v4.5a1 1 0 001 1z" />
  </svg>
);

export default SvgFolderFile1;
